// src/App.jsx
import { createElement as e } from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { AuthProvider, useAuth } from './hooks/useAuth';
import { initializeStorage } from './data/store';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Empleados from './pages/Empleados';
import Puestos from './pages/Puestos';
import Horarios from './pages/Horarios';
import Vacantes from './pages/Vacantes';
import Citas from './pages/Citas';
import Settings from './pages/Settings';
import Asistencia from './pages/Asistencia';
import DashboardAsistencia from './pages/DashboardAsistencia';
import Dispositivos from './pages/Dispositivos';
import Documentos from './pages/Documentos';

initializeStorage();

// Ruta privada: requiere login
function PrivateRoute() {
    const { user } = useAuth();
    if (!user) return e(Navigate, { to: '/login', replace: true });
    return e(Layout, null, e(Outlet, null));
}

// Ruta con permiso especifico: redirige a dashboard si no tiene el permiso
function PermRoute(props) {
    const { can } = useAuth();
    if (!can(props.permission)) return e(Navigate, { to: '/dashboard', replace: true });
    return e(Outlet, null);
}

export default function App() {
    return e(
          BrowserRouter,
          null,
          e(
                  AuthProvider,
                  null,
                  e(
                            Routes,
                            null,
                            e(Route, { path: '/login', element: e(Login, null) }),
                            e(Route, { path: '/asistencia', element: e(Asistencia, null) }),
                            e(
                                        Route,
                              { element: e(PrivateRoute, null) },
                                        e(Route, { path: '/dashboard', element: e(Dashboard, null) }),
                                        e(
                                                      Route,
                                          { element: e(PermRoute, { permission: 'canViewEmployees' }) },
                                                      e(Route, { path: '/empleados', element: e(Empleados, null) })
                                                    ),
                                        e(
                                                      Route,
                                          { element: e(PermRoute, { permission: 'canViewPuestos' }) },
                                                      e(Route, { path: '/puestos', element: e(Puestos, null) })
                                                    ),
                                        e(
                                                      Route,
                                          { element: e(PermRoute, { permission: 'canViewSchedules' }) },
                                                      e(Route, { path: '/horarios', element: e(Horarios, null) })
                                                    ),
                                        e(
                                                      Route,
                                          { element: e(PermRoute, { permission: 'canViewVacantes' }) },
                                                      e(Route, { path: '/vacantes', element: e(Vacantes, null) })
                                                    ),
                                e(
                                        Route,
                                    { element: e(PermRoute, { permission: 'canDownloadWorkPlans' }) },
                                        e(Route, { path: '/documentos', element: e(Documentos, null) })
                                    ),
                                        e(
                                                      Route,
                                          { element: e(PermRoute, { permission: 'canViewCitas' }) },
                                                      e(Route, { path: '/citas', element: e(Citas, null) })
                                                    ),
                                        e(
                                                      Route,
                                          { element: e(PermRoute, { permission: 'canViewAsistencia' }) },
                                                      e(Route, { path: '/admin/asistencia', element: e(DashboardAsistencia, null) })
                                                    ),
                                        e(
                                                      Route,
                                          { element: e(PermRoute, { permission: 'canManageDevices' }) },
                                                      e(Route, { path: '/dispositivos', element: e(Dispositivos, null) })
                                                    ),
                                        e(
                                                      Route,
                                          { element: e(PermRoute, { permission: 'canManageRoles' }) },
                                                      e(Route, { path: '/settings', element: e(Settings, null) })
                                                    )
                                      ),
                            e(Route, { path: '*', element: e(Navigate, { to: '/dashboard', replace: true }) })
                          )
                )
        );
}
